import { TextureLoader, Texture, RepeatWrapping } from 'three';

const loader = new TextureLoader();
const cache = new Map<string, Texture>();

export function loadTextureCached(url: string, repeatX = 1, repeatY = 1): Texture {
  if (cache.has(url)) return cache.get(url)!;
  const tex = loader.load(url);
  tex.wrapS = RepeatWrapping;
  tex.wrapT = RepeatWrapping;
  tex.repeat.set(repeatX, repeatY);
  cache.set(url, tex);
  return tex;
}

export const TEXTURE_URLS = {
  perforationMailles: '/textures/perforation-mailles.png',
  ribPattern: '/textures/rib-pattern.png',
  rivetHex: '/textures/rivet-hex.png',
};
